import { Component, Input } from '@angular/core';
import { FooterComponent, FooterComponentData } from '../footer.model';

@Component({
  selector: 'app-dpltelematics-footer',
  templateUrl: './dpltelematics-footer.component.html',
  styleUrls: ['./dpltelematics-footer.component.scss'],
})
export class DpltelematicsFooterComponent implements FooterComponent {
  @Input() data: FooterComponentData;
}
